import React from 'react';
import LoaderImage from './assets/loader/loader.gif'; // Adjust the path as necessary
import { Box, Typography } from '@mui/material';

const LoadingSpinner = ({ fullPage = false }) => {
  return (
    <Box>
      <Box
      width={'100vw'}
      height={'100vh'}
      zIndex={'10000'}
      bgcolor={'#fff'}
      position={'absolute'}
      top={'0'}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      >
        <img src={LoaderImage} alt="Loading..." style={{ width: 100, height: 100 }} />
        <Typography variant="h5" sx={{ marginTop: 2, color: "black" }}>
          Loading, please wait...
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingSpinner;